export const currencyOptions = [
  { code: "USD", name: "US Dollar", symbol: "$" },
  { code: "EUR", name: "Euro", symbol: "€" },
  { code: "GBP", name: "British Pound", symbol: "£" },
  { code: "JPY", name: "Japanese Yen", symbol: "¥" },
  { code: "AUD", name: "Australian Dollar", symbol: "A$" },
  { code: "CAD", name: "Canadian Dollar", symbol: "C$" },
  { code: "CHF", name: "Swiss Franc", symbol: "CHF" },
  { code: "CNY", name: "Chinese Yuan", symbol: "¥" },
  { code: "SEK", name: "Swedish Krona", symbol: "kr" },
  { code: "NZD", name: "New Zealand Dollar", symbol: "NZ$" },
  { code: "MXN", name: "Mexican Peso", symbol: "$" },
  { code: "SGD", name: "Singapore Dollar", symbol: "S$" },
  { code: "HKD", name: "Hong Kong Dollar", symbol: "HK$" },
  { code: "NOK", name: "Norwegian Krone", symbol: "kr" },
  { code: "KRW", name: "South Korean Won", symbol: "₩" },
  { code: "TRY", name: "Turkish Lira", symbol: "₺" },
  { code: "RUB", name: "Russian Ruble", symbol: "₽" },
  { code: "INR", name: "Indian Rupee", symbol: "₹" },
  { code: "BRL", name: "Brazilian Real", symbol: "R$" },
  { code: "ZAR", name: "South African Rand", symbol: "R" },
  { code: "PLN", name: "Polish Zloty", symbol: "zł" },
  { code: "ILS", name: "Israeli New Shekel", symbol: "₪" },
  { code: "CZK", name: "Czech Koruna", symbol: "Kč" },
  { code: "HUF", name: "Hungarian Forint", symbol: "Ft" },
  { code: "AED", name: "United Arab Emirates Dirham", symbol: "د.إ" },
  { code: "SAR", name: "Saudi Riyal", symbol: "﷼" },
  { code: "RON", name: "Romanian Leu", symbol: "lei" },
  { code: "DKK", name: "Danish Krone", symbol: "kr" },
  { code: "MYR", name: "Malaysian Ringgit", symbol: "RM" },
  { code: "THB", name: "Thai Baht", symbol: "฿" },
  { code: "IDR", name: "Indonesian Rupiah", symbol: "Rp" },
  { code: "PHP", name: "Philippine Peso", symbol: "₱" },
  { code: "PKR", name: "Pakistani Rupee", symbol: "₨" },
  { code: "CLP", name: "Chilean Peso", symbol: "$" },
  { code: "COP", name: "Colombian Peso", symbol: "$" },
  { code: "EGP", name: "Egyptian Pound", symbol: "£" },
  { code: "NGN", name: "Nigerian Naira", symbol: "₦" },
  { code: "VND", name: "Vietnamese Dong", symbol: "₫" },
  { code: "BDT", name: "Bangladeshi Taka", symbol: "৳" },
  { code: "UAH", name: "Ukrainian Hryvnia", symbol: "₴" },
  { code: "KZT", name: "Kazakhstani Tenge", symbol: "₸" },
  { code: "LKR", name: "Sri Lankan Rupee", symbol: "Rs" },
  { code: "MAD", name: "Moroccan Dirham", symbol: "د.م." },
  { code: "TWD", name: "New Taiwan Dollar", symbol: "NT$" },
  { code: "KES", name: "Kenyan Shilling", symbol: "KSh" },
  { code: "GHS", name: "Ghanaian Cedi", symbol: "₵" },
  { code: "XOF", name: "West African CFA Franc", symbol: "CFA" },
  { code: "XAF", name: "Central African CFA Franc", symbol: "FCFA" },
  { code: "BHD", name: "Bahraini Dinar", symbol: ".د.ب" },
  { code: "QAR", name: "Qatari Riyal", symbol: "﷼" },
  { code: "JOD", name: "Jordanian Dinar", symbol: "د.ا" },
  { code: "OMR", name: "Omani Rial", symbol: "﷼" },
];

// Helper function to get currency symbol from currency code
export const getCurrencySymbol = (currencyCode: string): string => {
  const currency = currencyOptions.find(c => c.code === currencyCode);
  return currency?.symbol || "$"; // Default to $ if not found
};

// Popular currencies (most commonly used worldwide)
export const popularCurrencyCodes = [
  "USD", // US Dollar
  "EUR", // Euro
  "GBP", // British Pound
  "JPY", // Japanese Yen
  "CNY", // Chinese Yuan
  "AUD", // Australian Dollar
  "CAD", // Canadian Dollar
  "CHF", // Swiss Franc
  "INR", // Indian Rupee
  "BRL", // Brazilian Real
];

// Auto-detect currency based on user's browser locale
export const detectUserCurrency = (): string => {
  try {
    // Get user's locale from browser
    const locale = navigator.language || 'en-US';
    
    // Map common locales to currencies
    const localeMap: Record<string, string> = {
      'en-US': 'USD', 'en-GB': 'GBP', 'en-AU': 'AUD', 'en-CA': 'CAD', 'en-NZ': 'NZD',
      'fr': 'EUR', 'de': 'EUR', 'es': 'EUR', 'it': 'EUR', 'pt': 'EUR', 'nl': 'EUR',
      'fr-FR': 'EUR', 'de-DE': 'EUR', 'es-ES': 'EUR', 'it-IT': 'EUR', 'pt-PT': 'EUR',
      'ja': 'JPY', 'ja-JP': 'JPY',
      'zh': 'CNY', 'zh-CN': 'CNY',
      'ko': 'KRW', 'ko-KR': 'KRW',
      'hi': 'INR', 'hi-IN': 'INR',
      'pt-BR': 'BRL',
      'es-MX': 'MXN',
      'es-AR': 'ARS',
      'ru': 'RUB', 'ru-RU': 'RUB',
      'tr': 'TRY', 'tr-TR': 'TRY',
      'pl': 'PLN', 'pl-PL': 'PLN',
      'sv': 'SEK', 'sv-SE': 'SEK',
      'no': 'NOK', 'nb-NO': 'NOK',
      'da': 'DKK', 'da-DK': 'DKK',
      'fi': 'EUR',
      'he': 'ILS', 'he-IL': 'ILS',
      'ar': 'SAR', 'ar-SA': 'SAR',
      'th': 'THB', 'th-TH': 'THB',
      'vi': 'VND', 'vi-VN': 'VND',
      'id': 'IDR', 'id-ID': 'IDR',
      'ms': 'MYR', 'ms-MY': 'MYR',
      'zh-HK': 'HKD',
      'zh-TW': 'TWD',
      'en-SG': 'SGD',
      'en-ZA': 'ZAR',
    };
    
    // Check exact locale match first
    if (localeMap[locale]) {
      return localeMap[locale];
    }
    
    // Check language only (first part before '-')
    const lang = locale.split('-')[0];
    if (localeMap[lang]) {
      return localeMap[lang];
    }
    
    // Default to USD if no match
    return 'USD';
  } catch (error) {
    console.warn('Could not detect user currency:', error);
    return 'USD';
  }
};

export const currencyToLocale: Record<string, string> = {
  USD: "en-US", // US Dollar
  EUR: "fr-FR", // Euro (France)
  GBP: "en-GB", // British Pound
  JPY: "ja-JP", // Japanese Yen
  AUD: "en-AU", // Australian Dollar
  CAD: "en-CA", // Canadian Dollar
  CHF: "de-CH", // Swiss Franc
  CNY: "zh-CN", // Chinese Yuan
  SEK: "sv-SE", // Swedish Krona
  NZD: "en-NZ", // New Zealand Dollar
  MXN: "es-MX", // Mexican Peso
  SGD: "en-SG", // Singapore Dollar
  HKD: "zh-HK", // Hong Kong Dollar
  NOK: "nb-NO", // Norwegian Krone
  KRW: "ko-KR", // South Korean Won
  TRY: "tr-TR", // Turkish Lira
  RUB: "ru-RU", // Russian Ruble
  INR: "hi-IN", // Indian Rupee
  BRL: "pt-BR", // Brazilian Real
  ZAR: "en-ZA", // South African Rand
  PLN: "pl-PL", // Polish Zloty
  ILS: "he-IL", // Israeli Shekel
  CZK: "cs-CZ", // Czech Koruna
  HUF: "hu-HU", // Hungarian Forint
  AED: "ar-AE", // UAE Dirham
  SAR: "ar-SA", // Saudi Riyal
  RON: "ro-RO", // Romanian Leu
  DKK: "da-DK", // Danish Krone
  MYR: "ms-MY", // Malaysian Ringgit
  THB: "th-TH", // Thai Baht
  IDR: "id-ID", // Indonesian Rupiah
  PHP: "en-PH", // Philippine Peso
  PKR: "ur-PK", // Pakistani Rupee
  CLP: "es-CL", // Chilean Peso
  COP: "es-CO", // Colombian Peso
  EGP: "ar-EG", // Egyptian Pound
  NGN: "en-NG", // Nigerian Naira
  VND: "vi-VN", // Vietnamese Dong
  BDT: "bn-BD", // Bangladeshi Taka
  UAH: "uk-UA", // Ukrainian Hryvnia
  KZT: "kk-KZ", // Kazakhstani Tenge
  LKR: "si-LK", // Sri Lankan Rupee
  MAD: "ar-MA", // Moroccan Dirham
  TWD: "zh-TW", // New Taiwan Dollar
  KES: "en-KE", // Kenyan Shilling
  GHS: "en-GH", // Ghanaian Cedi
  XOF: "fr-SN", // West African CFA Franc (Senegal)
  XAF: "fr-CM", // Central African CFA Franc (Cameroon)
  BHD: "ar-BH", // Bahraini Dinar
  QAR: "ar-QA", // Qatari Riyal
  JOD: "ar-JO", // Jordanian Dinar
  OMR: "ar-OM", // Omani Rial
  ARS: "es-AR", // Argentine Peso
  PEN: "es-PE", // Peruvian Sol
  DOP: "es-DO", // Dominican Peso
  UYU: "es-UY", // Uruguayan Peso
  BGN: "bg-BG", // Bulgarian Lev
  HRK: "hr-HR", // Croatian Kuna
  ISK: "is-IS", // Icelandic Krona
  TND: "ar-TN", // Tunisian Dinar
  MUR: "en-MU", // Mauritian Rupee
  LBP: "ar-LB", // Lebanese Pound
  BAM: "bs-BA", // Bosnian Convertible Mark
};
